import React, { useEffect, useState } from "react";
import "./CreateAccount.scss";
import { Icon } from "@iconify/react";
import {
  RegisterFb,
  auth,
  registerWithEmailAndPassword,
  signInWithGoogle,
} from "../../../firebase/firebase";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";

function CreateAccount() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [date, setDate] = useState("");
  const [erroremail, setErrorEmail] = useState(false);
  const [errorpassword, setErrorPassword] = useState(false);
  const [errordate, setErrorDate] = useState(false);
  const [userisLogged, setUserisLogged] = useState();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "email") {
      const emailRegex = /\S+@\S+\.\S+/;
      if (value !== "" && emailRegex.test(value)) {
        setEmail(value);
        setErrorEmail(false);
      } else {
        setErrorEmail(true);
        setEmail("");
      }
    } else if (e.target.type === "password") {
      if (e.target.value.length > 5) {
        setPassword(value);
        setErrorPassword(false);
      } else {
        setPassword("");
        setErrorPassword(true);
      }
    } else if (e.target.type === "date") {
      setDate(value);
    }
  };

  const signUp = async () => {
    // const emailValid = validateEmail();
    // const passwordValid = validatePassword();
    // const dateValid = validateDateOfBirth();
    if (email == "" && password == "" && date == "") {
    } else {
      await registerWithEmailAndPassword(email, password, date)
        .then((res) => {
          console.log(res);
          navigate("/login");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);
        navigate("/");
      } else {
        setUserisLogged(user);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleGoogle = () => {
    signInWithGoogle();
  };

  const handleFacebook = () => {
    RegisterFb();
  };

  const responseFacebook = (response) => {
    // Handle the response from Facebook here
    console.log(response);
  };

  useEffect(() => {
    console.log(userisLogged);
  }, [userisLogged]);

  return (
    <div>
      <div className="create-account">
        <div className="layer-shadow"></div>
        <div className="signIn-form">
          <div className="signIn-form-content">
            <img
              src="\assets\images\signin-logo.png"
              alt="singin-background-img"
              className="create-logo"
            />
            <h1>Sign Up</h1>
            <div className="input-box">
              <Icon
                icon="clarity:user-solid"
                color="white"
                width="22"
                height="28"
                className="ico"
              />
              <input
                type="text"
                name=""
                placeholder="First Name"
                id=""
                onChange={handleInputChange}
              />
            </div>
            <div className="input-box">
              <Icon
                icon="clarity:user-solid"
                color="white"
                width="22"
                height="28"
                className="ico"
              />
              <input
                type="text"
                name=""
                placeholder="Last Name"
                id=""
                onChange={handleInputChange}
              />
            </div>
            <div className="input-box">
              <Icon
                icon="clarity:user-solid"
                color="white"
                width="22"
                height="28"
                className="ico"
              />
              <input
                type="email"
                name=""
                placeholder="Username or Email"
                id=""
                onChange={handleInputChange}
              />
            </div>
            <p
              style={{
                margin: "0",
                color: "red",
                display: erroremail ? "block" : "none",
              }}
            >
              Please Enter Valid Email
            </p>
            <div className="input-box">
              <Icon
                icon="mdi:password"
                color="white"
                width="20"
                height="28"
                className="ico"
              />
              <input
                type="password"
                name=""
                placeholder="Password"
                id=""
                onChange={handleInputChange}
              />
            </div>
            <p
              style={{
                margin: "0",
                color: "red",
                display: errorpassword ? "block" : "none",
              }}
            >
              Password Length Should be greater than 6 character
            </p>
            {/* <div className="input-box">
              <Icon
                icon="material-symbols:date-range"
                color="white"
                width="30"
                height="28"
                className="ico"
              />
              <input
                type="date"
                name=""
                placeholder="Date of Birth"
                id=""
                onChange={handleInputChange}
              />
            </div> */}
            <p
              style={{
                margin: "0",
                color: "red",
                display: errordate ? "block" : "none",
              }}
            >
              Please Enter Valid Date
            </p>
            {/* <div className="input-box">
              <div className="something">
                <div className="connect-wallet">
                  <Icon
                    icon="ant-design:wallet-outlined"
                    color="white"
                    width="35"
                    height="28"
                    className="ico"
                  />
                  <p>Connect Wallet</p>
                </div>
                <div className="connect-btn">
                  <button>Connect</button>
                </div>
              </div>
            </div> */}
            {/* <h4 className="social-media-tit">Create Account Using</h4>
            <div className="social-media">
              <div className="cursor-pointer" onClick={handleGoogle}>
                <img
                  className="sign-up-google"
                  src="../../../../assets/images/signupgoogle.svg"
                  alt=""
                />
              </div>

              <div className="cursor-pointer" onClick={handleFacebook}>
                <img
                  className="sign-up-google"
                  src="../../../../assets/images/signupfacebook.svg"
                  alt=""
                />
              </div>
            </div> */}
            {/* <ReactFacebookLogin
                appId={process.env.REACT_APP_FB_APP_ID}
                autoLoad={false} // Set to true if you want the button to auto-load on page load
                fields="name,email,picture" // Customize the data you want to retrieve
                callback={responseFacebook}
                render={(renderProps) => (
                  <button onClick={renderProps.onClick}>Login with Facebook</button>
                )}
              /> */}
            <button
              className="signin-btn"
              onClick={() => {
                signUp();
              }}
            >
              Create Account
            </button>
            <div className="f-pass">
              <p>OR</p>
            </div>
            <div className="create-account-btn">
              <button
                onClick={() => {
                  navigate("/login");
                }}
              >
                Sign In
              </button>
            </div>
          </div>
        </div>
        {/* <div className="create-video">
          <video autoPlay loop>
            <source
              src="../../../../assets/videos/SignInPage_Background.mp4"
              type="video/mp4"
            />
          </video>
        </div> */}
      </div>
    </div>
  );
}

export default CreateAccount;
